import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OccEndpointsService } from '@spartacus/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DocumentSpecificSearchService {
  inPdp: boolean = false;
  popupClosed = new BehaviorSubject<Boolean>(false);
  constructor(private http: HttpClient, private occService: OccEndpointsService) { }

  getCustomDocumentDetails(searchDetails: { docType: any; productCategory: any; language: any; }, pageSize: any, query: any, currentPage: any, sort?: any) {
    return this.http.get(this.occService.buildUrl(`mydocuments/kbdocument?pageSize=${pageSize}&page=${currentPage}&searchText=${query}&docType=${searchDetails?.docType}&docCategory=${searchDetails?.productCategory}&docLanguage=${searchDetails?.language}&sort=${sort}`));
  }
  getDocSearchPage() {
    return this.http.get(this.occService.buildUrl(`kbsdocumentLibrary/form`));
  }
  getDownloadPopup() {
    return this.http.get(this.occService.buildUrl(`mydocuments/getuserdetail`));
  }
  getDoubleOpt(docCode: any, value: any) {
    return this.http.get(this.occService.buildUrl(`mydocuments/document-update-request/doubleopt?documentId=${docCode}&documentValue=${value}`));
  }
  postListingPage(data: any) {
    return this.http.post(this.occService.buildUrl(`mydocuments/submit`), data);
  }
  postSubscribe(data: { code: any; email: any; name: any; revision: any; language: any; }) {
    return this.http.post(this.occService.buildUrl(`mydocuments/document-subscribe?documentCode=${data.code}&email=${data.email}&name=${data.name}&revision=${data.revision}&documentLanguage=${data.language}`), null);
  }
  myFavDocListPage(currentPage: any, pageSize: any, sort?: any) {
    return this.http.get(this.occService.buildUrl(`mydocuments/getfavoritelist?currentPage=${currentPage}&pageSize=${pageSize}&sort=${sort}`));
  }
  removeDocandUnsubscribe(data: { code: any; catalogId: any; }, langIso: any) {
    return this.http.post(this.occService.buildUrl(`mydocuments/removedocumentfavoritepage?documentCode=${data.code}&documentLanguage=${langIso}&catalogId=${data.catalogId}`), null)
  }
  removeFavFromPdp(data: any) {
    return this.http.post(this.occService.buildUrl(`mydocuments/removedocumentpdppage?documentCode=${data.code}&documentLanguage=${data.language}`), null);
  }
  removeFavDoc(data: any) {
    return this.http.post(this.occService.buildUrl(`mydocuments/removedocumentotherpage?documentCode=${data.code}&documentLanguage=${data.language}`), null);
  }
  addToFavFromPdp(data: any) {
    return this.http.post(this.occService.buildUrl(`mydocuments/adddocumenttofavoritelistpdppage?documentCode=${data.code}&documentLanguage=${data.language}&email=${data.email}&name=${data.name}&revision=${data.revision}`), null);
  }
  exceptPdpAddToFavFrom(data: any) {
    return this.http.post(this.occService.buildUrl(`mydocuments/adddocumenttofavoritelistotherpage?documentCode=${data.code}&documentLanguage=${data.language}&email=${data.email}&name=${data.name}&revision=${data.revision}`), null);
  }

}
